import { QBox, QFlex } from '@qualio/ui-components';
import { MutableRefObject, useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useElementSize } from '../../../../../hooks/ElementSize';

export const ImageDocumentViewerV2 = ({
  attachmentPreviewUrl,
  zoom,
}: {
  attachmentPreviewUrl: string;
  zoom: number;
}) => {
  const { t } = useTranslation();

  const wrapper = useRef<HTMLDivElement>() as MutableRefObject<HTMLDivElement>;
  const { width: wrapperWidth } = useElementSize(wrapper);

  const baseImageSize = useRef<{ width: number; height: number } | null>(null);
  const [imageSize, setImageSize] = useState<{
    width: number;
    height: number;
  } | null>(null);

  useLayoutEffect(() => {
    if (baseImageSize.current) {
      const newWidth = baseImageSize.current.width * zoom;
      const newHeight = baseImageSize.current.height * zoom;
      setImageSize({ width: newWidth, height: newHeight });
    }
  }, [zoom]);

  return (
    <QFlex width="100%" ref={wrapper} direction="column" alignItems="center">
      <QBox
        ml={0}
        border="1px"
        borderColor="gray.200"
        boxShadow="md"
        overflowX="auto"
        overflowY="hidden"
        height={imageSize?.height}
        maxWidth={wrapperWidth}
      >
        <img
          onLoad={(e) => {
            baseImageSize.current ??= {
              width: e.currentTarget.offsetWidth,
              height: e.currentTarget.offsetHeight,
            };
          }}
          style={{
            maxWidth: 'none',
          }}
          src={attachmentPreviewUrl}
          alt={t('altText.preview')}
          width={imageSize?.width ?? '100%'}
          height={imageSize?.height ?? 'auto'}
        />
      </QBox>
    </QFlex>
  );
};
